<template>
  <pre
    class="font-mono overflow-auto text-xs w-full h-full p-1 px-2 pb-7 rounded-box bg-neutral-focus text-neutral-content"
    ref="consoleOutput"
    v-html="firmware.consoleOutputHtml"
  ></pre>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useFirmwareStore } from "@/stores";

const firmware = useFirmwareStore();
const consoleOutput = ref<HTMLElement | null>(null);

const scroll = () => {
  if (consoleOutput.value == null) return;
  consoleOutput.value.scrollTop = consoleOutput.value.scrollHeight;
};

watch(
  () => firmware.consoleOutputCount,
  (newCount) => {
    if (newCount == 0) return;
    // Run the scrolling now, but also in next event cycle to make sure we actually
    // scroll till the end.
    scroll();
    setTimeout(scroll);
  }
);

defineExpose({ scroll });
</script>
